'use strict';

/**
 * This file simply overrides some of Leaflet's core functionality to enable custom behaviour.
 * It is executed when the module is loaded in the "run" callback.
 */

require('leaflet.markercluster');
require('./leaflet/DrawText.js');
require('./leaflet/GeometryUtil.js');
require('./leaflet/GeoJSON.js');
require('./leaflet/FontMarker.js');
require('./leaflet/ShapeMarker.js');

function MapSetup () {
  if (L.mapbox){
    // TODO @andre Move token to config
    L.mapbox.accessToken = 'pk.eyJ1Ijoic2t5Y2F0Y2gtZGV2IiwiYSI6Ik1PVjVYNEkifQ.j2X9OOZDz7ABqUvHk4kesw';
  }

  // Override the normal openPopup behavior so that we can have all popups open at once
  // and ensure that clicking somewhere on the map does not close them
  L.Map = L.Map.extend({
    openPopup: function(popup) {
      this._popup = popup;

      this._popup.options.autoPan = false;
      this._popup.options.closeOnClick = false;
      this._popup.options.closeButton = false;

      return this.addLayer(popup).fire('popupopen', {
        popup: this._popup
      });
    }
  });
}

MapSetup.$inject = [];
module.exports = MapSetup;



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/MapSetup.js